// extracted by mini-css-extract-plugin
export default {"banner":"m22JFBm","content":"Z_1omcv","image":"LfvJ74V","textContainer":"ujWyZ3_","headline":"paa7q3M","text":"vVi7BU4"};